// extracted by mini-css-extract-plugin
export var activeIndex = "KpiGridSection-module--activeIndex--19523";
export var cMarginTop = "KpiGridSection-module--c-margin-top--b5607";
export var cPadding = "KpiGridSection-module--c-padding--c2f39";
export var cPaddingBottom = "KpiGridSection-module--c-padding-bottom--87780";
export var cPaddingTop = "KpiGridSection-module--c-padding-top--7d661";
export var card = "KpiGridSection-module--card--ac271";
export var cards = "KpiGridSection-module--cards--b25f8";
export var content = "KpiGridSection-module--content--ba753";
export var date = "KpiGridSection-module--date--87ecf";
export var disabled = "KpiGridSection-module--disabled--8aaf8";
export var ellipsis = "KpiGridSection-module--ellipsis--d204a";
export var featuredSection = "KpiGridSection-module--featuredSection--0fc5f";
export var globalSpacing = "KpiGridSection-module--global-spacing--17b6c";
export var globalSpacingBottom = "KpiGridSection-module--global-spacing-bottom--e8d0e";
export var globalSpacingTop = "KpiGridSection-module--global-spacing-top--2ce15";
export var headingBar = "KpiGridSection-module--headingBar--055be";
export var image = "KpiGridSection-module--image--89a07";
export var imageWrapper = "KpiGridSection-module--imageWrapper--bbe3d";
export var index = "KpiGridSection-module--index--2ca33";
export var innerCard = "KpiGridSection-module--innerCard--96049";
export var listItem = "KpiGridSection-module--listItem--19118";
export var maxWidth = "KpiGridSection-module--max-width--6484e";
export var navButton = "KpiGridSection-module--navButton--6c105";
export var pagination = "KpiGridSection-module--pagination--2871f";
export var para = "KpiGridSection-module--para--ee653";
export var sectionBox = "KpiGridSection-module--sectionBox--12f31";
export var styleTick = "KpiGridSection-module--styleTick--48bdc";
export var subTitle = "KpiGridSection-module--subTitle--0bfa3";
export var tag = "KpiGridSection-module--tag--f8dfa";
export var tagWrapper = "KpiGridSection-module--tagWrapper--33fe4";
export var title = "KpiGridSection-module--title--b2ad8";